import { create } from "zustand";

export const useTabStore = create((set) => ({
    activeTab: {
        value: "en-attente",
        index: 0,
        tag: "LISTE_REMONTEES",
    },
    setActiveTab: (tab) => set({ activeTab: tab }),
}));
